import React from 'react';
import { RegularButton } from '../button';
import { CloseIcon } from '../icons';
import styles from './styles/modal.module.css';

const ButtonComponent = ({
  onClick,
  ...componentProps
}) => /*#__PURE__*/React.createElement(RegularButton, {
  variant: "pseudo",
  "aria-label": "Close modal",
  onClick: onClick,
  rounded: true,
  iconOnly: true,
  ...componentProps
}, /*#__PURE__*/React.createElement(CloseIcon, null));

export const ModalCloseButton = ({
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.closeButtonWrapper
}, /*#__PURE__*/React.createElement(ButtonComponent, {
  className: styles.closeButtonDesktop,
  onClick: onClose,
  size: "l"
}), /*#__PURE__*/React.createElement(ButtonComponent, {
  className: styles.closeButtonMobile,
  onClick: onClose,
  size: "s"
}));